import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail1Sparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmail1Sparkle"><Path d="M22 15.6084L21.5596 15.4395L20.4307 12.5H17.5693L16.4395 15.4395L13.5 16.5693V19.4307L14.9834 20H2V5.78613L12 13.9688L22 5.78613V15.6084Z" fill="currentColor"/><Path d="M12 12.0312L2.18359 4H21.8164L12 12.0312Z" fill="currentColor"/><Path d="M19.4 14H18.6L17.6 16.6L15 17.6V18.4L17.6 19.4L18.6 22H19.4L20.4 19.4L23 18.4V17.6L20.4 16.6L19.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail1Sparkle;
